import React, { useState } from 'react';
import { DropdownMenu, Search, SparkIcon, TagGeneral } from '@spark';

const USER_TYPE_OPTIONS = ['All Users', 'Admin', 'Editor', 'Viewer', 'Unassigned'];

export default function UserFilters({ value, onChange }) {
    const [typeOpen, setTypeOpen] = useState(false);
    const v = value || { query: '', role: '' };
    const roleLabel = v.role || 'All Users';

    return (
        <div className="settings-users__filters">
            <DropdownMenu
                className="settings-users__type-filter"
                showLabel={false}
                placeholder=""
                text=""
                value={roleLabel}
                open={typeOpen}
                onOpenChange={setTypeOpen}
                prefixIcon={(
                    <>
                        <SparkIcon slug="filter" size="small" />
                        <span className="settings-users__type-label">User type</span>
                        <TagGeneral label={roleLabel} />
                    </>
                )}
                items={USER_TYPE_OPTIONS.map((label) => ({ label }))}
                onSelect={(item) => {
                    const nextRole = item.label === 'All Users' ? '' : item.label;
                    onChange?.({ ...v, role: nextRole });
                    setTypeOpen(false);
                }}
            />
            <div className="settings-users__search">
                <Search
                    size="medium"
                    placeholder="Search"
                    value={v.query}
                    onChange={(e) => onChange?.({ ...v, query: e.target.value })}
                    onClear={() => onChange?.({ ...v, query: '' })}
                />
            </div>
        </div>
    );
}
